import type { TranscriptSummaryStatus } from "@/layouts/AppLayout/IncomingCallEventIntegration/queries";

export const FLEX_SUMMARY_IN_PROGRESS =
  "Call summary is being generated from the transcript and will update here momentarily...";
export const FLEX_SUMMARY_FAILED = "Call summary could not be generated.";
export const FLEX_SUMMARY_UNAVAILABLE = "No call transcript was available for summarization.";

export const FLEX_SUMMARY_PLACEHOLDER_MESSAGES = [
  FLEX_SUMMARY_IN_PROGRESS,
  FLEX_SUMMARY_FAILED,
  FLEX_SUMMARY_UNAVAILABLE
] as const;

export type FlexTwilioCallSummary = {
  transcriptSummaryStatus: TranscriptSummaryStatus;
};

export const isFlexSummaryPlaceholder = (content?: string | null): boolean => {
  const normalized = content?.trim();
  if (!normalized) return false;

  return FLEX_SUMMARY_PLACEHOLDER_MESSAGES.includes(normalized as (typeof FLEX_SUMMARY_PLACEHOLDER_MESSAGES)[number]);
};

export const isFlexSummaryPending = (status?: TranscriptSummaryStatus | null): boolean =>
  status === "pending" || status === "processing";

export const isFlexInteractionEditLocked = ({
  messageContent,
  twilioFlexCall
}: {
  messageContent?: string | null;
  twilioFlexCall?: FlexTwilioCallSummary | null;
}): boolean => {
  if (!twilioFlexCall) return false;

  return isFlexSummaryPlaceholder(messageContent) && isFlexSummaryPending(twilioFlexCall.transcriptSummaryStatus);
};
